// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"1da08aa0","369":"8700d976","371":"e727536b","711":"a3820ca0","715":"b80597e3","896":"5849690e"}[chunkId] + ".chunk.css";
};